(() => {
  'use strict';
  if (window.veloraDawnProductLoaded) return;
  window.veloraDawnProductLoaded = true;

  const selector = 'product-info[data-velora-pdp]';
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function syncPicker(root) {
    const picker = root.querySelector('variant-selects');
    if (!picker) return;
    picker.querySelectorAll('fieldset').forEach((group) => {
      const legend = group.querySelector('legend');
      const selected = group.querySelector('input:checked');
      if (!legend || !selected) return;
      if (!legend.dataset.veloraOptionName) {
        legend.dataset.veloraOptionName = selected.dataset.optionName || legend.textContent.trim();
      }
      const label = legend.dataset.veloraOptionName.toLocaleUpperCase('hu-HU') + ': ';
      if (legend.dataset.veloraSelected === selected.value && legend.querySelector('[data-selected-value]')) return;
      const value = document.createElement('span');
      value.dataset.selectedValue = '';
      value.textContent = selected.value;
      legend.replaceChildren(document.createTextNode(label), value);
      legend.dataset.veloraSelected = selected.value;
    });
  }

  function syncForm(root) {
    const button = root.querySelector('button[id^="ProductSubmitButton-"]');
    const label = button?.querySelector('span');
    if (label && !label.classList.contains('product-form__submit-label')) label.classList.add('product-form__submit-label');
    const form = root.querySelector('product-form form');
    if (form && !form.hasAttribute('data-velora-base-form')) form.setAttribute('data-velora-base-form', '');
    if (button && !button.hasAttribute('data-velora-native-buy')) button.setAttribute('data-velora-native-buy', '');
  }

  function syncGallery(root) {
    const viewer = root.querySelector('[id^="GalleryViewer-"]');
    const slider = viewer?.querySelector('.product__media-list');
    if (!slider) return;
    // only the gallery items themselves: the zoom button inside each item carries data-media-id too
    const slides = [...slider.querySelectorAll(':scope > [data-media-id]')];
    if (slides.length < 1) {
      viewer.querySelector('.velora-gallery-dots')?.remove();
      return;
    }
    const signature = slides.map((slide) => slide.dataset.mediaId).join('|');
    let dots = viewer.querySelector('.velora-gallery-dots');
    if (!dots) {
      dots = document.createElement('div');
      dots.className = 'velora-gallery-dots';
      viewer.append(dots);
    }
    if (dots.dataset.slides !== signature) {
      dots.dataset.slides = signature;
      dots.replaceChildren(...slides.map((slide, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('aria-label', (index + 1) + '. termékkép');
        button.setAttribute('aria-controls', slider.id);
        button.dataset.mediaId = slide.dataset.mediaId;
        button.addEventListener('click', () => {
          slider.scrollTo({ left: slide.offsetLeft - slides[0].offsetLeft, behavior: reducedMotion() ? 'instant' : 'smooth' });
        });
        return button;
      }));
    }
    if (!viewer.dataset.veloraDotsBound) {
      viewer.dataset.veloraDotsBound = 'true';
      viewer.addEventListener('slideChanged', (event) => {
        const current = event.detail.currentElement;
        updateDots(viewer, current?.dataset.mediaId);
      });
    }
    const active = slides.find((slide) => slide.classList.contains('is-active')) || slides[0];
    updateDots(viewer, active.dataset.mediaId);
  }

  function updateDots(viewer, mediaId) {
    viewer.querySelectorAll('.velora-gallery-dots button').forEach((button) => {
      const current = String(button.dataset.mediaId === mediaId);
      if (button.getAttribute('aria-current') !== current) button.setAttribute('aria-current', current);
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-velora-product-tabs]').forEach((tabs) => {
      if (tabs.dataset.veloraTabsReady) return;
      tabs.dataset.veloraTabsReady = 'true';
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      const activate = (active) => {
        buttons.forEach((button) => {
          const selected = button === active;
          button.setAttribute('aria-selected', String(selected));
          button.tabIndex = selected ? 0 : -1;
          tabs.querySelector('#' + CSS.escape(button.getAttribute('aria-controls'))).hidden = !selected;
        });
      };
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => activate(button));
        button.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = buttons[(index + 1) % buttons.length];
          if (event.key === 'ArrowLeft') next = buttons[(index + buttons.length - 1) % buttons.length];
          if (event.key === 'Home') next = buttons[0];
          if (event.key === 'End') next = buttons[buttons.length - 1];
          if (!next) return;
          event.preventDefault();
          activate(next);
          next.focus();
        });
      });
      if (buttons.length) activate(buttons[0]);
    });
  }

  function init() {
    document.querySelectorAll(selector).forEach((root) => {
      const sync = () => {
        syncPicker(root);
        syncForm(root);
        syncGallery(root);
        initTabs(root);
      };
      sync();
      if (root.dataset.veloraAdapterReady) return;
      root.dataset.veloraAdapterReady = 'true';
      let queued = false;
      const schedule = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => { queued = false; sync(); });
      };
      const observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true });
      root.addEventListener('change', schedule);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) observer.disconnect();
      }, { once: true });
    });
  }

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-velora-size-open]');
    if (opener) document.getElementById(opener.dataset.veloraSizeOpen)?.showModal();
    const closer = event.target.closest('[data-velora-size-close]');
    if (closer) closer.closest('dialog')?.close();
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-info:loaded', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
